__turbopack_context__.v({
  "address": "SnsResolve-module__aE54Wa__address",
  "error": "SnsResolve-module__aE54Wa__error",
  "num": "SnsResolve-module__aE54Wa__num",
  "root": "SnsResolve-module__aE54Wa__root",
});
